<script setup lang="ts">
defineProps<{
  subtitle?: string;
  title: string;
  titleClasses?: string;
}>();
</script>

<template>
  <div class="flex min-w-[200px] flex-col">
    <h1 :class="['text-xl font-semibold leading-6 text-gray-900', titleClasses]">
      <slot name="title">{{ $t(title) }}</slot>
    </h1>

    <p
      v-if="subtitle"
      class="text-sm text-slate-500"
    >
      {{ $t(subtitle) }}
    </p>
  </div>
</template>
